import { getApi } from "../../services/httpService";



export function city(){
    return getApi().get('home/city');
}
